import { userExist, userNotExist } from "../redux/features/userSlice";
import { getUser } from "../services/user.service";

// Cache to prevent multiple simultaneous API calls
let userDataCache = null;
let isUserDataFetching = false;
let userDataPromise = null;

const getUserData = async (dispatch, setUser, setbalance) => {
	try {
		// If already fetching, return the existing promise
		if (isUserDataFetching && userDataPromise) {
			const data = await userDataPromise;
			if (setbalance && data) {
				setbalance(data.walletBalance);
			}
			return data;
		}

		// If we have cached data and it's recent (less than 30 seconds), use it
		if (userDataCache && Date.now() - userDataCache.timestamp < 30000) {
			if (setbalance) {
				setbalance(userDataCache.data.walletBalance);
			}
			return userDataCache.data;
		}

		// Set fetching flag and create promise
		isUserDataFetching = true;
		userDataPromise = getUser();

		const data = await userDataPromise;
		
		if (data) {
			// Cache the data
			userDataCache = {
				data,
				timestamp: Date.now()
			};

			if (setbalance) {
				setbalance(data.walletBalance);
			}
			
			const user = {
				_id: data._id,
				name: data.name,
				phone: data.phone,
				email: data.email,
				verified: data.verified,
				walletBalance: data.walletBalance,
				role: data.role,
				profilePicture: data.profilePicture
			}
			
			if (dispatch) {
				if (setUser === null) {
					dispatch(userNotExist());
				} else {
					dispatch(userExist(user));
				}
			}
		} else {
			localStorage.removeItem("token");
			if (dispatch) {
				dispatch(userNotExist());
			}
		}
		
		return data;
	} catch (error) {
		console.log(error);
		if (dispatch) {
			dispatch(userNotExist());
		}
		throw error;
	} finally {
		isUserDataFetching = false;
		userDataPromise = null;
	}
};

// Function to clear cache when user logs out or data needs refresh
export const clearUserDataCache = () => {
	userDataCache = null;
	isUserDataFetching = false;
	userDataPromise = null;
};

export default getUserData;
